import {Table} from "react-bootstrap";
import {useSelector} from "react-redux";
import {noten} from "../../data/noten";
import Calculations from "../../helpers/calculations";
import ThreeFields from "./ThreeFields";

const SchuelerDetailsBerlin = ({props}) => {
  const {activeId} = props;
  const schuelerlist = useSelector(st => st.schueler);
  const schueler = schuelerlist.find(s => s.id === activeId);
  const currentKlausur = useSelector(st => st.currentKlausur);
  const calculations = new Calculations(schueler, currentKlausur);
  // console.log({calculations})
  const {entwurf} = schueler;
  console.log({entwurf});

  const {
    sumAfb1Bis3AnteilRounded,
    prozentAufgabenbearbeitung,
    aufgabenBearbeitungGewichtung,
    sprachePointsAnteil,
    erreichteGesamtpunktzahl,
    resultPointsRounded
  } = calculations.results.Berlin;

  const gesamtbewertung = (
    <Table className="text-right">
      <thead>
        <tr>
          <th>Gesamtbewertung</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <th>Bereiche</th>
          <th>Punkte</th>
          <th>Gewichtung</th>
          <th>Ergebnis</th>
          <th>Gesamtpunkte</th>
          <th>Gesamtnote</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Aufgabenbearbeitung</td>
          <td>{sumAfb1Bis3AnteilRounded}</td>
          <td>{`${prozentAufgabenbearbeitung} %`}</td>
          <td>{aufgabenBearbeitungGewichtung.toFixed(2)}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Sprachverwendung</td>
          <td>{parseInt(schueler.sprachePoints)}</td>
          <td>{`${currentKlausur.sprachverwendung} %`}</td>
          <td>{sprachePointsAnteil.toFixed(2)}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colSpan={3}>erreichte Gesamtpunktzahl</td>
          <td>{erreichteGesamtpunktzahl.toFixed(2)}</td>
          <td>{resultPointsRounded}</td>
          <td>{noten[`0${resultPointsRounded}`.slice(-2)]}</td>
        </tr>
      </tbody>
    </Table>
  );

  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Feld</th>
            <th>Wert</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Lese- /Rechtschreibschwierigkeit (nur bei Notenschutz)</td>
            <td>{schueler.leseschwaeche ? "ja" : "nein"}</td>
          </tr>

          <ThreeFields
            schueler={schueler}
            gewichtung={currentKlausur.prozentAfb1}
            props={props}
            fieldnames={["afb1Points", "afb1Tb", "afb1Remarks"]}
          />
          <ThreeFields
            schueler={schueler}
            klausur={currentKlausur}
            gewichtung={currentKlausur.prozentAfb2}
            props={props}
            fieldnames={["afb2Points", "afb2Tb", "afb2Remarks"]}
          />
          <ThreeFields
            schueler={schueler}
            klausur={currentKlausur}
            gewichtung={currentKlausur.prozentAfb3}
            props={props}
            fieldnames={["afb3Points", "afb3Tb", "afb3Remarks"]}
          />
          <ThreeFields schueler={schueler} gewichtung="100" props={props} fieldnames={["sprachePoints", "spracheTb", "spracheRemarks"]} />
          <tr>
            <td>Zusammenfassung</td>
            <td>{schueler.zusammenfassung}</td>
          </tr>
        </tbody>
      </Table>
      <hr></hr>
      <h6>Ergebnisse</h6>
      {entwurf ? <p>Zum Anzeigen der Gesamtbewertung füllen Sie bitte alle Felder aus, und speichern es als Gutachten</p> : gesamtbewertung}

    </div>
  );
};
export default SchuelerDetailsBerlin;
